import { render, staticRenderFns } from "./warnDetail.vue?vue&type=template&id=3423dd2e&scoped=true&"
import script from "./warnDetail.vue?vue&type=script&lang=js&"
export * from "./warnDetail.vue?vue&type=script&lang=js&"
import style0 from "./warnDetail.vue?vue&type=style&index=0&id=3423dd2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423dd2e",
  null
  
)

export default component.exports